// extracted by mini-css-extract-plugin
module.exports = {"Insiders":"Insiders_Insiders__fAIDq","data":"Insiders_data__pJjy_","chip-container":"Insiders_chip-container__gWb1Y","chip":"Insiders_chip__VS0ZK"};